import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { History } from 'history'
import { authReducer } from 'ducks/auth/reducer'
import { referencesReducer } from 'ducks/references/reducer'
import { estimatesReducer } from 'ducks/estimates/reducer'
import { profileReducer } from 'ducks/profile/reducers'
import { privacyPolicyReducer } from '../ducks/privacyPolicy/reducers'
import { patientsReducer } from '../ducks/patients/reducers'
import { footerReducer } from '../ducks/footer/reducers'
import { loadingReducer } from '../ducks/loading/reducer'
import { cmsReducer } from '../ducks/cms/reducer'
import { MostActiveCpt4CodesReducer } from '../ducks/mostActiveCpt4/reducers'

export default (history: History) =>
  combineReducers({
    router: connectRouter(history),
    auth: authReducer,
    references: referencesReducer,
    estimates: estimatesReducer,
    profile: profileReducer,
    privacyPolicy: privacyPolicyReducer,
    patients: patientsReducer,
    footer: footerReducer,
    loading: loadingReducer,
    cms: cmsReducer,
    mostActiveCpt4: MostActiveCpt4CodesReducer
  })
